import React from 'react';
import reduxFetch from 'react-redux-fetch';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { GetOrganisationId } from 'nallian-shared-ui/lib/selectors';
import { OFF_PREMISE_ACCESS_RIGHTS_RESOURCE } from './offPremiseAccessRightsService';
import { VEHICLE_ACCESS_RIGHTS_RESOURCE } from '../../vehicleSidebar/services/vehicleAccessRightsService';
import { getErrorCodeConvertor } from '../../app/lib/errorCodeConvertor';
import apiRoutes from '../../../app/api/routes';

function mapStateToProps(state) {
  return {
    organisationId: GetOrganisationId(state),
  };
}
export default ComposedComponent =>
  compose(
    withTranslation(),
    connect(mapStateToProps),
    reduxFetch(props => [
      {
        resource: 'requestAccessRight',
        method: 'post',
        request: (body, redirectRoute) => ({
          body: { onPremiseId: props.organisationId, ...body },
          url: apiRoutes.requestAccessRight(),
          meta: {
            toaster: {
              onSuccessMessage: props.t('accessRightRequestSuccess'),
              onErrorMessage: getErrorCodeConvertor(props.t, 'accessRightRequestErr'),
            },
            redirectRoute,
            addToOtherLists: [
              {
                listPath: 'values',
                resource: OFF_PREMISE_ACCESS_RIGHTS_RESOURCE,
              },
              {
                listPath: 'values',
                resource: VEHICLE_ACCESS_RIGHTS_RESOURCE,
              },
            ],
          },
        }),
      },
    ])
  )(props => <ComposedComponent {...props} />);
